import React from "react";
import { RSButton } from "reactsymbols-kit";
import Styles from "../../styles/colors";

interface KeyboardShortcutsProps {
  /** Function to call if the view should be closed. */
  onRequestClose?: () => void;
}

/**
 * An overview of the keyboard shortcuts.
 */
const KeyboardShortcuts = ({ onRequestClose }: KeyboardShortcutsProps) => {
  return (
    <div className="merlin-modal keyboard-shortcuts min-w-[400px]">
      <div className="title">Keyboard shortcuts</div>
      <div className="modal-body">
        <div className="container">
          <div className="row">
            <div className="col">
              <dl className="flex w-[400px] flex-wrap">
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  h or F1
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">Show this help window</dd>
              </dl>
              <dl className="flex w-[400px] flex-wrap">
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  e
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">Toggle EDG</dd>
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  shift+e
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">Show EDG</dd>
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  o
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">Toggle OET</dd>
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  shift+o
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">Show OET</dd>
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  f
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">Toggle FSMs</dd>
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  shift+f
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">Show FSMs</dd>
              </dl>
              <dl className="flex w-[400px] flex-wrap">
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  del
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">
                  Delete currently selected element
                </dd>
                <dt className="basis-[30%] pr-[15px] text-right font-mono font-bold">
                  esc
                </dt>
                <dd className="m-0 mb-[5px] basis-[70%]">
                  Deselect the currently selected element
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div className="button-wrapper">
        <RSButton
          background={Styles.defaultGradient}
          color={Styles.darkTextColor}
          value="Close"
          onClick={onRequestClose}
        />
      </div>
    </div>
  );
};

export default KeyboardShortcuts;
